module.exports = __webpack_public_path__ + "media/assets/svg/illustrations/hiker-man-582aa6065f3daca653cadec014bf0a82.svg";